import React from 'react';
import './App.css';
import Card from './components/Card';


const App = () => {


  return (
    <div className="App">
      <Card />
    </div>
  );
}

export default App;
